import { PrivilegeLevels } from "../../shared/constants/PrivilegeLevels";

export const UserMenuItems = [
    {
      title: 'Profile',
      link: '/profile',
      accessibility: PrivilegeLevels.user.level,
    },
  ];
  